import apiClient from "../api/client";

import {
  AttractorImageDto,
  SaveAttractorImageDto,
  AttractorLoopListDto,
  AttractorLoopDetailsDto,
  AttractorLoopSaveDto,
  PagedResultDto
} from "../types/attractortypes";

export async function getAttractorLoops(
  pageNumber: number = 1,
  pageSize: number = 10,
  search?: string,
  active?: boolean | null
): Promise<PagedResultDto<AttractorLoopListDto>> {
  const response = await apiClient.get<PagedResultDto<AttractorLoopListDto>>('/api/Attractor', {
    params: {
      pageNumber,
      pageSize,
      search: search || undefined,
      active: active === null ? undefined : active
    }
  });
  return response.data;
}

export async function createAttractorLoop(name: string, createdBy?: string): Promise<string> {
  const response = await apiClient.post<{ guid: string }>('/api/Attractor', { name, createdBy });
  return response.data.guid;
}

export async function getAttractorLoopDetails(guid: string): Promise<AttractorLoopDetailsDto> {
  const response = await apiClient.get<AttractorLoopDetailsDto>(`/api/Attractor/${guid}`);
  return response.data;
}

export async function saveAttractorLoopDetails(
  guid: string,
  data: AttractorLoopSaveDto,
  updatedBy?: string
): Promise<void> {
  await apiClient.put(`/api/Attractor/${guid}`, data, {
    params: { updatedBy }
  });
}

export async function deleteAttractorLoop(guid: string): Promise<void> {
  await apiClient.delete(`/api/Attractor/${guid}`);
}
